/**
 * 돌봄서비스 페이지 컴포넌트
 * 6가지 돌봄서비스(장애인활동지원, 노인장기요양, 가사간병, 돌봄SOS, 사회주택, 상담문의)의
 * 상세 정보를 표시하는 페이지입니다.
 */

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '../template/SubPage';
import CareServiceInfo from '../components/care/CareServiceInfo';
import CareContactInfo from '../components/care/CareContactInfo';
import { getList } from '../api/';
import { MENU_DATA, getSubMenuLabel } from '../constant/menuData';
import { CONTACT_PAGE_NO } from '../constant/careData';
import MyHelmet from '../hooks/Helmet';

function CarePage() {
  const no = useParams().no;
  const [submenu, setSubMenu] = useState('장애인활동지원서비스');

  // 서비스 번호에 해당하는 상세 정보 데이터 가져오기
  const List = getList(no);

  // 메뉴 데이터 가져오기
  const menuData = MENU_DATA.care;

  useEffect(() => {
    setSubMenu(getSubMenuLabel('care', no) || '장애인활동지원서비스');
  }, [no]);

  // 페이지별 서브메뉴 타이틀
  const getPageMeta = () => {
    const metaData = {
      1: { pageTitle: '장애인활동지원' },
      2: { pageTitle: '노인장기요양서비스' },
      3: { pageTitle: '가사간병방문지원서비스' },
      4: { pageTitle: '돌봄SOS서비스' },
      5: { pageTitle: '사회주택' },
      6: { pageTitle: '사회적경제기업 창업·성장지원 사업' },
      7: { pageTitle: `DSI 사회혁신 사업\n(DIGITAL SOCIAL INNOVATION)` },
      8: { pageTitle: '상담 문의' },
    };
    return metaData[no] || metaData['1'];
  };

  const pageMeta = getPageMeta();

  return (
    <>
      <MyHelmet />
      <SubPage
        title={menuData.label}
        description={menuData.description}
        menuItems={menuData.subMenus}
        currentNo={no}
        submenu={submenu}
        submenuTitle={pageMeta.pageTitle}
        breadcrumbMenu={menuData.label}
        breadcrumbLink={menuData.path}
      >
        {no === CONTACT_PAGE_NO ? (
          <CareContactInfo />
        ) : (
          <CareServiceInfo List={List} no={no} />
        )}
      </SubPage>
    </>
  );
}

export default CarePage;
